import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router'

import {usePageData} from '_metronic/layout/core'

import Parent from './components/user/Parent'
import Student from './components/user/Student'
import VendorAdd from './components/vendors/Add'
import VendorList from './components/vendors/List'

type Props = {
  /**
   * `button` — labelled button (original toolbar look).
   * `icon` — icon-only button styled like the other header navbar items.
   * `menu` — a Metronic `menu-item` row, for the profile menu on phones.
   */
  variant?: 'button' | 'icon' | 'menu'
  /** Wrapper class; only applied when the popup has content for this route. */
  className?: string
}

const HelpPopup: FC<Props> = ({variant = 'button', className}) => {
  const intl = useIntl()
  const {pageTitle} = usePageData()
  const {pathname} = useLocation()

  const [componentTitle, setComponentTitle] = useState('')
  const [showModal, setShowModal] = useState(false)

  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleHideModal = () => {
    setShowModal(false)
  }

  let Component
  switch (pathname.toLocaleLowerCase()) {
    case '/institute/user/student':
      Component = Student
      break
    case '/institute/user/parent':
      Component = Parent
      break
    case '/institute/vendors/list':
      Component = VendorList
      break
    case '/institute/vendors/add':
      Component = VendorAdd
      break
  }

  if (!Component) {
    return null
  }

  const helpLabel = intl.formatMessage({id: 'GENERAL.HELP'})

  return (
    <>
      {variant === 'menu' ? (
        <div className={className ?? 'menu-item px-5'}>
          <span className='menu-link px-5 cursor-pointer' onClick={handleShowModal}>
            <span className='menu-icon'>
              <i className='fa fa-circle-question fs-3' />
            </span>
            <span className='menu-title'>{helpLabel}</span>
          </span>
        </div>
      ) : variant === 'icon' ? (
        <div className={className}>
          <button
            type='button'
            className='btn btn-icon text-muted btn-active-light-primary btn-custom'
            onClick={handleShowModal}
            title={helpLabel}
            aria-label={helpLabel}
          >
            <i className='fa fa-circle-question' style={{fontSize: '20px'}} />
          </button>
        </div>
      ) : (
        <div className={className ?? 'd-flex align-items-center py-1'}>
          <div className='me-4'>
            <button
              type='button'
              className='btn btn-sm btn-flex btn-light-primary fw-bolder'
              onClick={handleShowModal}
            >
              <span className='fa fa-circle-info mx-1'></span>
              {helpLabel}
            </button>
          </div>
        </div>
      )}

      <Modal show={showModal} onHide={handleHideModal} size='lg' centered>
        <Modal.Header closeButton>
          <Modal.Title>{componentTitle !== '' ? componentTitle : pageTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Component setTitle={(title: string) => setComponentTitle(title)} />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default HelpPopup
